import React, { Fragment } from 'react';
import HeaderPortal from '../../../components/layout/HeaderPortal';
import PermissionCheck from 'components/common/PermissionCheck';
import TaxRateListBrowser from './TaxRateListBrowser';
import { ADMIN_TAX_RATES_READ } from 'constants/rightsCodes';

const Route = () => {
  return (
    <Fragment>
      <HeaderPortal />
      <PermissionCheck authorizationCode={ADMIN_TAX_RATES_READ}>
        <TaxRateListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

export default Route;
